import { Utils } from '../services';

class Http {
    getUrl(url) {
        return `${Utils.getConfig().serverEndPoint}${url}`;
    }

    getHeaders() {
        const headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        };
        return headers;
    }

    getParamsString(params) {
        let stringParams = '?';
        if (params) {
            stringParams += Object.getOwnPropertyNames(params)
                .map(x => `${x}=${params[x]}`)
                .join('&');
        }
        return stringParams;
    }

    async getResponse(request) {
        const response = await request.json();
        switch (request.status) {
            case 200:
                return response;

            default:
                throw new Error(response.message);
        }
    }

    async get(url, params = null, header = null, credentials = true) {
        let urlGet = `${url}${this.getParamsString(params)}`;
        if (!url.startsWith('http')) {
            urlGet = this.getUrl(urlGet);
        }
        if (!url) {
            throw new Error('Url é obrigatória.');
        }
        const request = await fetch(urlGet, {
            method: 'GET',
            headers: header || this.getHeaders(),
            credentials: credentials ? 'include' : 'omit',
        });
        return this.getResponse(request);
    }

    async delete(url, body) {
        if (!url) {
            throw new Error('Url é obrigatória.');
        }
        const request = await fetch(this.getUrl(url), {
            method: 'DELETE',
            body: JSON.stringify(body),
            headers: this.getHeaders(),
            credentials: 'include',
        });
        return this.getResponse(request);
    }

    async post(url, body, header = null, credentials = true) {
        let urlPost = url;
        if (!url.startsWith('http')) {
            urlPost = this.getUrl(url);
        }
        if (!urlPost) {
            throw new Error('Url é obrigatória.');
        }
        const request = await fetch(urlPost, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: header || this.getHeaders(),
            credentials: credentials ? 'include' : 'omit',
        });
        return this.getResponse(request);
    }

    async put(url, body) {
        if (!url) {
            throw new Error('Url é obrigatória.');
        }
        const request = await fetch(this.getUrl(url), {
            method: 'PUT',
            body: JSON.stringify(body),
            headers: this.getHeaders(),
            credentials: 'include',
        });
        return this.getResponse(request);
    }
}

const http = new Http();
export default http;
